module.exports = __webpack_public_path__ + "static/media/nb4.03265c73.jpg";